import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Form } from 'common/components';
import { createRoute } from 'lib/util';

class AssetsActionDisable extends PureComponent {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
    subcompanyId: PropTypes.string.isRequired,
    assetId: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  render = () => (
    <Form.Link
      className="btn btn-sm btn-outline-danger w-100 my-1"
      to={createRoute(
        this.props.companyId,
        this.props.subcompanyId,
        `assets/${this.props.assetId}/disable`
      )}
    >
      {this.props.t('actions.disable')}
    </Form.Link>
  );
}

export default translate()(AssetsActionDisable);



// WEBPACK FOOTER //
// src/components/assets/actions/AssetsActionsDisable.js